// extracted by mini-css-extract-plugin
export default {"primary-blue":"#00A1DE","action-orange":"#db6e21","background-dark-grey":"#BDBFBF"};